var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYouTubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6 2.09524C19.4 1.2381 18.7 0.666667 17.8 0.380952C16.3 8.51495e-08 10 0 10 0C10 0 3.7 8.51495e-08 2.2 0.380952C1.3 0.571429 0.6 1.2381 0.4 2.09524C8.9407e-08 3.52381 0 6.66667 0 6.66667C0 6.66667 8.9407e-08 9.80952 0.4 11.2381C0.6 12.0952 1.3 12.6667 2.2 12.9524C3.7 13.3333 10 13.3333 10 13.3333C10 13.3333 16.3 13.3333 17.8 12.9524C18.7 12.7619 19.3 12.0952 19.6 11.2381C20 9.80952 20 6.66667 20 6.66667C20 6.66667 20 3.52381 19.6 2.09524ZM8 9.52381V3.80952L13.2 6.66667L8 9.52381Z",
    fill: "#4B2B5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTubeIcon);
export default __webpack_public_path__ + "static/media/youTubeIcon.91505458bf3481ccac86d0d69db84e7b.svg";
export { ForwardRef as ReactComponent };